import React from 'react'

const Transform = () => {
  return (
    <div className='dark:bg-darker-theme bg-light-theme-black'>
    <div className='2xl:max-w-screen-2xl 2xl:mx-auto Transform  gap-4 py-16 p-6 justify-center flex flex-col text-center items-center lg:px-52'>
      <h1 className='font-bold text-sm font-josefin sm:text-lg md:text-xl lg:text-3xl'>Transforming businesses through exceptional IT solutions</h1>
    </div></div>
  )
}

export default Transform
